import { Center, Text } from "@chakra-ui/react"

interface ITableEmptyState {
  T: any
  isReportsPage: boolean
}

const TableEmptyState = ({ T, isReportsPage }: ITableEmptyState) => {
  return (
    <Center w="100%" padding="15px 0">
      {
        isReportsPage && <Text fontSize="m">{T("excel.data_not_found")}</Text>
      }
    </Center>
  )
}

export default TableEmptyState